import React from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './PatientsGroupsHistoryListItem.module.scss';
import { getMomentDate } from '../../../../Utils/dates.util';
import { useAppContext } from '../../../../Services/AppContext';

interface Props {
	item: {
		createdAt: string;
		createdBy: {
			profile: {
				fullName: string;
			};
		};
		text: string;
	};
}

const PatientsGroupsHistoryListItem: React.FC<Props> = ({ item }) => {
	const { dateFormatMoment } = useAppContext();

	return (
		<div className={styles.wrapper}>
			<div className={joinClasses([styles.col, styles.colDate])}>
				{getMomentDate(item.createdAt).format(dateFormatMoment + ', HH:mm')}
			</div>
			<div className={joinClasses([styles.col, styles.colUser])}>
				{item.createdBy?.profile?.fullName}
			</div>
			<div className={joinClasses([styles.col, styles.colDetail])}>
				{item.text}
			</div>
		</div>
	);
};

export default PatientsGroupsHistoryListItem;
